export default __webpack_public_path__ + "static/media/alphabet-yellow-b.1bfd2d55.png";